import withStyles from "react-jss"
import { TRANSITION_DURATION } from "../styles/globalStyles"
const styles = {
  svg: {
    marginRight: "16px",
  },
}

const MuteIcon = ({ classes, playing }) => {
  const fill = playing ? "#E373FF" : "#000000"
  return (
    <svg
      className={classes.svg}
      width="18"
      height="18"
      viewBox="0 0 36 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g
        style={{
          fill,
          transition: `fill ${TRANSITION_DURATION} ease-in`,
        }}>
        <rect x="18.8739" y="8.06927" width="2.73535" height="2.73535" />
        <rect x="18.8739" y="18.8739" width="2.73535" height="2.73535" />
        <rect x="21.6093" y="13.54" width="2.73535" height="2.73535" />
        <rect x="21.6093" y="16.2753" width="2.73535" height="2.73535" />
        <rect x="21.6093" y="10.8046" width="2.73535" height="2.73535" />
        <rect x="27.2168" y="8.06927" width="2.73535" height="2.73535" />
        <rect x="27.2168" y="18.8739" width="2.73535" height="2.73535" />
        <rect x="24.4813" y="5.33392" width="2.73535" height="2.73535" />
        <rect x="24.6182" y="21.6093" width="2.73535" height="2.73535" />
        <rect x="27.2168" y="13.54" width="2.73535" height="2.73535" />
        <rect x="27.2168" y="16.2753" width="2.73535" height="2.73535" />
        <rect x="27.2168" y="10.8046" width="2.73535" height="2.73535" />
        <rect x="33.0977" y="8.06927" width="2.73535" height="2.73535" />
        <rect x="33.0977" y="5.33392" width="2.73535" height="2.73535" />
        <rect x="33.0977" y="18.8739" width="2.73535" height="2.73535" />
        <rect x="33.0977" y="21.6093" width="2.73535" height="2.73535" />
        <rect x="30.3623" y="2.59857" width="2.73535" height="2.73535" />
        <rect x="30.3623" width="2.73535" height="2.73535" />
        <rect x="30.4991" y="24.3446" width="2.73535" height="2.73535" />
        <rect x="30.4991" y="27.0799" width="2.73535" height="2.73535" />
        <rect x="33.0977" y="13.54" width="2.73535" height="2.73535" />
        <rect x="33.0977" y="16.2753" width="2.73535" height="2.73535" />
        <rect x="33.0977" y="10.8046" width="2.73535" height="2.73535" />
        <path d="M16.2753 29.8153L16.2753 0.136765L13.54 0.136765V2.54313H10.8046V5.48425H7.65898V8.15799H0L0 21.7941H7.65898V24.4678H10.8046L10.8046 27.4089H13.54V29.8153H16.2753Z" />
      </g>
    </svg>
  )
}

export default withStyles(styles)(MuteIcon)
